<dialog-window [title]="title" (close)="close()" [modal]="false" focusOnCloseButton="true">
    <div (click)="load_prev_epg()" (keyup.enter)="load_prev_epg()" class="ion load_prev_epg" tabindex="1" title="Загрузить EPG"></div>
<ul>
    <li class="date">{{EPG_Bundle.epg[0]?.start*1000 | date:'dd/MM'}}</li>
    <ng-container *ngFor="let epg of EPG_Bundle.epg; index as i">
   <li [class]="epg.chronology" [ngClass]="{played: epg == EPG_Bundle.played_programm}"
       (mouseenter)="epg.chronology != 'next' ? li_mouseenter($event) : null" 
        [tabIndex]="epg.chronology != 'next' ? 1 : -1"
        (keydown.enter)="archive_play(i)">
        <b class="time" >{{epg.start*1000 | date:'HH:mm'}}</b>
        <b class="pointTime" (click)="archive_play(i)" title="Включить начало передачи"
           >{{(epg.pointTime ? epg.pointTime*1000 : epg.start*1000) | date:'HH:mm'}}</b>
        - <i>{{epg.programm}}</i>
        <div *ngIf="epg.chronology == 'current'" class="progress"><div [ngStyle]="{width: (epg.progress)+'%'}"></div></div>
        <input *ngIf="epg.chronology != 'next'" type="range" min="0" max="100" step="0.01" class="archive_range"
        [value]="epg.chronology == 'current' || epg == EPG_Bundle.played_programm ? epg.progress : 0" 
        (change)="archive_play(i, $event); $event.target.style = '--value: '+ $event.target.value + '%';"
        (mousemove)="archive_pointer(i, $event)"
        (mouseout)="epg.pointTime = epg.start"
        (input)="$event.target.style = '--value: '+ $event.target.value + '%' "
        [style] = "'--value: '+(epg.chronology == 'current' || epg == EPG_Bundle.played_programm ? epg.progress : 0)+'%'"
        (touchmove)="archive_pointer(i, $event)"
        title="Включение канала из Архива" tabindex="-1">
    </li>
    <li *ngIf="epg | epgDayChanged : EPG_Bundle.epg[i+1]" class="date">{{EPG_Bundle.epg[i+1]?.start*1000 | date:'dd/MM'}}</li>
    </ng-container>
</ul>
</dialog-window>